/* eslint-disable no-useless-computed-key */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useCallback, useRef } from 'react';
import clsx from 'clsx';
import { useDispatch, useSelector } from "react-redux";
import customStyles from "../../../../../assets/styles/customStyles";
import MainHeader from "../../../../Shared/components/Header";
import PrimaryCard from "../../../../Shared/components/Card/PrimaryCard";
import { Row, Col, Image, Space, Typography } from "antd";
import { Button, TextField, Box } from "@mui/material";
import SearchIcon from "../../../../../assets/images/icon_actions/Search Icon.svg";
import AddIcon from "../../../../../assets/images/icon_actions/Add Icon.svg";
import { NavLink } from "react-router-dom";
import SalesIcon from "../../../../../assets/images/icon_menus/SalesIcon.json";
import { PrimaryDrawer } from "../../../../Shared/components/Drawer/PrimaryDrawer";
import { CustomerGroupTable } from "./CustomerGroupTable";
import actions from "../../redux/actions";
import crudActions from "../../../../CRUD/redux/actions";
import usePrevious from "../../../../Shared/components/Previous";
import { toast } from 'react-toastify';
import ImportIcon from "../../../../../assets/images/icon_actions/Import.svg";
import ExportIcon from "../../../../../assets/images/icon_actions/Export.svg";
import { ImportExport } from '../../../../Shared/components/ImportExport';
import { useEventListener } from "../../../../../helpers/useEventListener";
import { checkViewPermission, checkCRUDPermission, checkComponentPermission, idNamingConversion } from '../../../../../helpers/utilities';
import { emptyValidation } from "../../../../../helpers/validation";
import DeleteModal from "../../../../Shared/components/DeleteModal";
import ClearIcon from "../../../../../assets/images/icon_actions/Clear Icon.svg";


const CustomersGroup = (props) => {
    const { customerGroupdetails, loader } = useSelector(state => state.salesSetupReducer);
    const { createDetails, createError, createLoader, getList, getData, editDetails, editError, editLoader } = useSelector(state => state.crudReducer);
    const [visible, setVisible] = useState(false);
    const [deleteModal, setDeleteModal] = useState(false);
    const { roleManagement } = useSelector(state => state.authReducer);
    const [addMore, setAddMore] = useState(false);
    const [search, setSearch] = useState('');
    const [iconAnimation, setIconAnimation] = useState(false);
    const prevCreateDetails = usePrevious(createDetails);
    const prevCreateError = usePrevious(createError);
    const prevEditDetails = usePrevious(editDetails);
    const prevEditError = usePrevious(editError);
    const prevSearch = usePrevious(search);
    const timeoutRef = useRef(null);
    const [skip, setSkip] = useState(0);
    const limit = 25;
    const [loadMore, setLoadMore] = useState(false);
    const [loadMoreContent, setLoadMoreContent] = useState(false);
    const [importVisible, setImportVisible] = useState(false);
    const [sortOrder, setSortOrder] = useState("desc");
    const [sortBy, setSortBy] = useState("id");
    const [form, setForm] = useState({});
    const [error, setError] = useState({});
    const [view, setView] = useState(false);

    const { history } = props;

    const handleOpen = () => {
        setVisible(true);
    };

    const handleClose = () => {
        setVisible(false);
        emptyStateInput();
        emptyState();
    };

    const dispatch = useDispatch();

    useEffect(() => {
        if ((prevSearch !== undefined && search && search.length > 2 && prevSearch !== search) || (prevSearch !== undefined && search === '' && prevSearch !== search)) {
            if (timeoutRef.current !== null) {
                clearTimeout(timeoutRef.current);
            }
            if (search === '') {
                dispatchFilter(search, sortBy, sortOrder);
            } else {
                timeoutRef.current = setTimeout(() => {
                    timeoutRef.current = null;
                    dispatchFilter(search, sortBy, sortOrder);
                }, 500);
            }
        }
    }, [search]);

    useEffect(() => {
        if (roleManagement !== '') {
            if (checkViewPermission('Customer Group', history, 'Sales')) {
                loadTasks();
            }
        }
    }, [roleManagement]);


    const handleKeyDown = (e) => {
        if (e.altKey && e.keyCode === 78) {
            e.preventDefault();
            setVisible(true);
        } else if (e.altKey && e.keyCode === 83) {
            e.preventDefault();
            createGroup(e);
        }
    }
    useEventListener("keydown", handleKeyDown);

    const prevGetData = usePrevious(getData);
    useEffect(() => {
        if (loadMore && getData === '') {
            setLoadMoreContent(false);
            setLoadMore(true);
        }
        if (prevGetData !== undefined && getData && prevGetData !== getData) {
            const timer = setTimeout(() => {
                if (getData && Array.isArray(getData) && getData.length > 0) {
                    setLoadMore(true);
                    if (getData.length < limit) {
                        setLoadMoreContent(false);
                    } else {
                        setLoadMoreContent(true);
                    }
                } else {
                    setLoadMoreContent(false);
                    setLoadMore(true);
                }
            });

            return () => {
                clearTimeout(timer);
            };
        }
    }, [getData]);


    const dispatchFilter = (search, sortBy, sortOrder, skip = 0) => {
        if (skip === 0) {
            setLoadMore(false);
            setLoadMoreContent(false);
        }
        let filter = { ["or"]: [] };
        if (search !== '') {
            filter['or'].push({ name: { like: '%' + search.trim() + '%' } });
            filter['or'].push({ description: { like: '%' + search.trim() + '%' } })
        }
        setSkip(skip);
        dispatch({
            type: crudActions.GET_DETAILS_START,
            url: 'customer-group',
            skip: skip,
            filter: {
                where: filter,
                order: sortBy + ' ' + sortOrder,
                limit: limit,
                skip: skip,
            }
        });
    }

    const loadTasks = useCallback(() => {
        dispatchFilter(search, sortBy, sortOrder);
    });

    const emptyState = () => {
        setError({})
    };

    const emptyStateInput = () => {
        setForm({});
    };



    useEffect(() => {
        if (prevCreateDetails !== undefined && createDetails && prevCreateDetails !== createDetails) {
            loadTasks();
            setVisible(false);
            toast.dismiss();
            // toast(createDetails);
            emptyStateInput();
            if (addMore) {
                setAddMore(false);
                setTimeout(function () {
                    setVisible(true);
                }, 500)
            }
        } else if (prevCreateError !== undefined && createError && prevCreateError !== createError) {
            setError({
                name: createError?.error?.message
            })
        }
    }, [createDetails, createError]);


    useEffect(() => {
        if (prevEditDetails !== undefined && editDetails && prevEditDetails !== editDetails) {
            loadTasks();
            toast.dismiss();
            // toast(editDetails);
            setVisible(false);
        } else if (prevEditError !== undefined && editError && prevEditError !== editError) {
            setError({
                name: editError?.error?.message
            })
        }
    }, [editDetails, editError]);


    const handleAddMore = (e) => {
        createGroup(e);
        setAddMore(true);
    }


    const requestSort = (sortBy, sortOrder) => {
        setSortBy(sortBy);
        setSortOrder(sortOrder);
        dispatchFilter(search, sortBy, sortOrder);
    }

    const loadMoreTask = () => {
        let s = skip + limit;
        dispatchFilter(search, sortBy, sortOrder, s);
    }

    const loadImportExportData = (name, data = 'existing', selected = [], extension = 'xlsx') => {
        dispatch({
            type: actions.CUSTOMERGROUP_DETAILS_START,
            export: name,
            data: data,
            selected: selected,
            extension: extension,
            url: 'customer-group',
            filter: {
                order: sortBy + ' ' + sortOrder,
            }
        });
    }
    const changeHandler = (e) => {
        setForm({
            ...form,
            [e.target.name]: e.target.value
        });
    }

    const onHandle = (data, view, visible) => {
        setForm(data);
        setVisible(visible);
        setView(view);
    };

    const createGroup = (e) => {
        e.preventDefault();
        let emptyName = emptyValidation('Group', form?.name);
        emptyState();
        if (emptyName.isValid) {
            Object.keys(form).forEach(k => !Number.isInteger(form[k]) && (form[k] = form[k].trim()));
            dispatch({
                type: form.id ? crudActions.EDIT_DETAILS_START
                    : crudActions.CREATE_DETAILS_START,
                url: 'customer-group',
                title: 'Customer group',
                id: form.id,
                details: form
            });
        } else {
            if (emptyName.errors) {
                setError({
                    name: emptyName.errors
                })
            }
        }
    }

    const onDelete = (data) => {
        setForm(data);
        setDeleteModal(true);
    }


    const classes = customStyles();
    return (
        <React.Fragment>
            <MainHeader {...props} cls={'newImg'} img={SalesIcon} title={'Sales'} links={[{ 'label': 'Sales', 'link': '/sales' }, { 'label': 'Customer Group', 'link': '' }]} />
            <div className={clsx(classes.margin40, classes.listTableMargin)}>
                <PrimaryCard
                    title={'Customer Group'}
                    component={
                        <>
                            <Row align="middle" className={classes.marginBottom20}>
                                <Col xxl={6} xl={7} lg={8} md={10} sm={13} xs={24}>
                                    {
                                        roleManagement !== '' && checkComponentPermission('Customer Group', 'Action', 'Search') &&
                                        <div className={clsx(classes.searchAnimation, { [classes.iconAnimation]: iconAnimation || search !== '' })}>
                                            <TextField autoComplete='one-time-code'
                                                placeholder='Search Group and Description'
                                                type='search'
                                                value={search}
                                                onChange={(e) => setSearch(e.target.value)}
                                                className={classes.comInput}
                                                required
                                                variant={'standard'}
                                                fullWidth
                                                id={idNamingConversion('Search', 'customerGroup', 'TextField')}
                                                onFocus={() => setIconAnimation(true)}
                                                onBlur={() => setIconAnimation(false)}
                                            />
                                            <Image
                                                src={SearchIcon}
                                                preview={false}
                                            />
                                            {
                                                search && <NavLink to="#" onClick={() => setSearch('')} className={classes.searchClear}>
                                                    <Image
                                                        src={ClearIcon}
                                                        preview={false}
                                                    />
                                                </NavLink>
                                            }
                                        </div>
                                    }
                                </Col>
                                <Col xxl={18} xl={17} lg={16} md={14} sm={11} xs={24} className={clsx(classes.textAlignRight, classes.vertiCalScrollOverFlowParent)}>
                                    <div className={classes.vertiCalScrollOverFlow}>
                                        <Space size={[20, 20]} direction="horizontal" align="center">
                                            {
                                                roleManagement !== '' && checkComponentPermission('Customer Group', 'Action', 'Export') &&
                                                <NavLink
                                                    to="#"
                                                    id={idNamingConversion('Export', 'customerGroup', 'Link')}
                                                    onClick={() => loadImportExportData('CustomerGroup')}
                                                    className={clsx(classes.customLink)}>
                                                    <Image
                                                        src={ExportIcon}
                                                        preview={false}
                                                        className={clsx(classes.antImage)}
                                                    /> <span className={clsx(classes.addLink, classes.color, classes.bold)}>Export</span>
                                                </NavLink>
                                            }
                                            {
                                                roleManagement !== '' && checkComponentPermission('Customer Group', 'Action', 'Import') &&
                                                <NavLink
                                                    to="#"
                                                    id={idNamingConversion('Import', 'customerGroup', 'Link')}
                                                    onClick={() => setImportVisible(true)}
                                                    className={clsx(classes.customLink)}>
                                                    <Image
                                                        src={ImportIcon}
                                                        preview={false}
                                                        className={clsx(classes.antImage)}
                                                    /> <span className={clsx(classes.addLink, classes.color, classes.bold)}>Import</span>
                                                </NavLink>
                                            }
                                            {
                                                roleManagement !== '' && checkCRUDPermission('Customer Group', 'create', 'Sales') &&
                                                <NavLink
                                                    to="#"
                                                    id={idNamingConversion('Add New Group', 'customerGroup', 'Link')}
                                                    onClick={() => onHandle({}, false, true)}
                                                    className={clsx(classes.customLink)}>
                                                    <Image
                                                        src={AddIcon}
                                                        preview={false}
                                                        className={clsx(classes.antImage)}
                                                    /><span className={clsx(classes.addLink, classes.color, classes.bold)}>Add New Group</span>
                                                </NavLink>
                                            }
                                        </Space>
                                    </div>
                                </Col>
                            </Row>
                            <CustomerGroupTable
                                search={search}
                                onHandle={(data, view, visible) => onHandle(data, view, visible)}
                                onDelete={(data) => onDelete(data)}
                                loadTasks={() => loadTasks()}
                                details={getList}
                                loadMore={loadMore}
                                handleOpen={() => handleOpen()}
                                roleManagement={roleManagement}
                                loadMoreContent={loadMoreContent}
                                loadMoreTask={() => loadMoreTask()}
                                sortOrder={sortOrder} sortBy={sortBy}
                                onRequestSort={(sortBy, sortOrder) => requestSort(sortBy, sortOrder)} />
                        </>
                    }
                />
            </div>
            <PrimaryDrawer
                open={visible}
                title={`${view ? 'View' : (form?.id ? 'Edit' : 'Add')} Customer Group`}
                anchor={'right'}
                variant={'temporary'}
                handleClose={() => handleClose()}
                className={clsx(classes.closeBackGround, classes.width100PCustomer)}
                component={
                    <Box
                        className={clsx(classes.customForm, classes.removeUnderline)}
                        component='form'
                        autoComplete='off'
                        onSubmit={(e) => createGroup(e)}
                        id={'customer-group'}>
                        <div className={classes.customFormFlex}>
                            {
                                view ?
                                    <>
                                        <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Customer Group</Typography>
                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form.name ? form.name : '---'}</Typography>
                                    </> :
                                    <TextField autoComplete='one-time-code'
                                        label={["Customer Group ", <span key={"Customer Group"} className={classes.colorRedRequired}> *</span>]}
                                        variant={'standard'}
                                        name={"name"}
                                        value={form?.name}
                                        error={error?.name ? true : false}
                                        helperText={error?.name}
                                        InputProps={{
                                            classes: {
                                                input: classes.textFieldColor,
                                            }
                                        }}
                                        id={idNamingConversion('Customer Group', 'customerGroup', 'TextField')}
                                        InputLabelProps={{
                                            className: classes.textFieldLableColorCustom,
                                        }}
                                        onChange={(e) => { changeHandler(e); }}
                                    />
                            }
                            {
                                view ?
                                    <>
                                        <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.margin20t, classes.fonSize13)}>Description</Typography>
                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form.description ? form.description : '---'}</Typography>
                                    </> : <TextField autoComplete='one-time-code'
                                        label={["Description "]}
                                        name={"description"}
                                        value={form?.description}
                                        multiline
                                        variant="outlined"
                                        className={clsx(classes.margin20t, classes.customDescription)}
                                        rows={4}
                                        InputProps={{
                                            classes: {
                                                input: classes.textFieldColor,
                                            }
                                        }}
                                        id={idNamingConversion('Description', 'customerGroup', 'TextField')}
                                        InputLabelProps={{
                                            className: classes.textFieldLableColor,
                                        }}
                                        onChange={(e) => { changeHandler(e); }}
                                    />
                            }

                        </div>
                        <div className={clsx(classes.btnParent)}>
                            <Space direction="horizontal" align="center" size={[10, 10]}>
                                {
                                    !view ? <><Button
                                        key="save"
                                        type='submit'
                                        color='primary'
                                        variant="contained"
                                        id={idNamingConversion('Save', 'customerGroup', 'Button')}
                                        className={clsx(classes.modalBtn, { [classes.loading]: createLoader || editLoader })}>
                                        {form?.id ? 'Update & Close' : 'Save & Close'}
                                    </Button> {
                                            !form?.id && <Button
                                                key="add"
                                                color='primary'
                                                variant="contained"
                                                onClick={(e) => handleAddMore(e)}
                                                id={idNamingConversion('Add More', 'customerGroup', 'Button')}
                                                className={clsx(classes.AddMoreBtn, { [classes.loading]: createLoader || editLoader })}>
                                                Add More
                                            </Button>
                                        }</> : <NavLink to={'#'} id={idNamingConversion('Edit', 'customerGroup', 'Link')} className={clsx(classes.modalBtn)} onClick={() => setView(false)}>Edit</NavLink>
                                }
                            </Space>
                        </div>
                    </Box>
                }
            />
            <DeleteModal onClose={(v) => setDeleteModal(v)}
                id={form?.id} loadTasks={() => loadTasks()} name={form?.name} url={'customer-group'} title={'Customer group'} visible={deleteModal} />
            <ImportExport
                handleClose={() => setImportVisible(false)}
                visible={importVisible}
                title={'CustomerGroup'}
                type={'import'}
                loader={loader}
                loadImportExportData={(name, type, selected, extension) => loadImportExportData(name, type, selected, extension)}
                details={customerGroupdetails}
                loadTasks={() => { dispatchFilter(sortBy, sortOrder) }}
            />
        </React.Fragment>
    )
}
export default CustomersGroup